import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue'
import AdminLayout from '../layouts/AdminLayout.vue'
import authStore from '../stores/auth'

/**
 * 业务页面一律懒加载：全部静态引入会把十个页面连同各自的表格、抽屉、
 * 表单塞进首屏 chunk，登录页也得等它们下载完才能渲染。
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/',
    component: AdminLayout,
    redirect: '/overview',
    children: [
      {
        path: '/operations',
        name: 'Operations',
        component: () => import('../pages/OperationsPage.vue'),
        meta: { title: '小程序运营中心' },
      },
      {
        path: '/overview',
        name: 'Overview',
        component: () => import('../pages/OverviewPage.vue'),
        meta: { title: '总览' },
      },
      {
        path: '/devices',
        name: 'Devices',
        component: () => import('../pages/DevicesPage.vue'),
        meta: { title: '设备与点位' },
      },
      {
        path: '/billing',
        name: 'Billing',
        component: () => import('../pages/BillingPage.vue'),
        meta: { title: '交易与财务' },
      },
      {
        path: '/alerts',
        name: 'Alerts',
        component: () => import('../pages/AlertsPage.vue'),
        meta: { title: '告警中心' },
      },
      {
        path: '/maintenance',
        name: 'Maintenance',
        component: () => import('../pages/MaintenancePage.vue'),
        meta: { title: '维保与库存' },
      },
      {
        path: '/content',
        name: 'Content',
        component: () => import('../pages/ContentPage.vue'),
        meta: { title: '内容与广告' },
      },
      {
        path: '/ota',
        name: 'OTA',
        component: () => import('../pages/OtaPage.vue'),
        meta: { title: 'OTA' },
      },
      {
        path: '/analytics',
        name: 'Analytics',
        component: () => import('../pages/AnalyticsPage.vue'),
        meta: { title: '数据分析' },
      },
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('../pages/SettingsPage.vue'),
        meta: { title: '用户与系统设置' },
      },
      {
        path: '/security',
        name: 'Security',
        component: () => import('../pages/SecurityPage.vue'),
        meta: { title: 'API 与安全中心' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

// Auth guard
router.beforeEach(async (to, from, next) => {
  // Try to restore auth on first app load
  if (!from.name && !authStore.isAuthenticated()) {
    if (authStore.refreshToken.value) {
      await authStore.tryRefresh()
    }
  }

  const isAuthenticated = authStore.isAuthenticated()
  const isLoginPage = to.path === '/login'

  if (isLoginPage) {
    // Already logged in, redirect to overview
    if (isAuthenticated) {
      next('/overview')
    } else {
      next()
    }
  } else {
    // Protected route
    if (!isAuthenticated) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
